import React from "react";
import Resources from "../../../../types/Resources";
import PersonFormElement from "../../../../types/forms/PersonFormElement";
import Button from "../../../Common/Button";

export type ParticipantListItem = {
    index: number;
} & PersonFormElement;

function ParticipantsList(props: {
    participantListItems: ParticipantListItem[];
    resources: Resources;
    showUpdateButton?: boolean;
    readOnly: boolean;
    onParticipantChange: (updatedParticipant: ParticipantListItem) => void;
    onAddParticipant: (addedParticipant: ParticipantListItem) => void;
    onRemoveParticipant: (removedParticipant: ParticipantListItem) => void;
    onUpdateButtonClick?: () => void;
}) {
    function isActiveChangeHandler(participant: ParticipantListItem, updatedIsActive: boolean) {
        const updatedParticipant: ParticipantListItem = { ...participant, isActive: updatedIsActive };
        props.onParticipantChange(updatedParticipant);
    }

    function nameChangeHandler(participant: ParticipantListItem, updatedName: string) {
        const updatedParticipant: ParticipantListItem = { ...participant, name: updatedName };
        props.onParticipantChange(updatedParticipant);
    }

    function phoneNumberChangeHandler(participant: ParticipantListItem, updatedPhoneNumber: string) {
        const updatedParticipant: ParticipantListItem = { ...participant, phoneNumber: updatedPhoneNumber };
        props.onParticipantChange(updatedParticipant);
    }

    function addParticipantClickHandler(clickedListItem: ParticipantListItem) {
        const addedParticipant: ParticipantListItem = {
            index: clickedListItem.index + 1,
            isActive: false,
            name: "",
            phoneNumber: ""
        };

        props.onAddParticipant(addedParticipant);
    }

    function removeParticipantClickHandler(clickedListItem: ParticipantListItem) {
        props.onRemoveParticipant(clickedListItem);
    }

    const participantElements = props.participantListItems.map((p) => (
        <li className="mt-2" key={p.index}>
            <div className="row">
                <div className="form-group col-1 text-center">
                    <input
                        className="form-check-input is-active"
                        type="checkbox"
                        checked={p.isActive}
                        onChange={(e) => isActiveChangeHandler(p, e.target.checked)}
                        disabled={props.readOnly}
                    />
                </div>
                <div className="form-group col-5 person-name">
                    <input
                        id={`participant-name-${p.index}`}
                        aria-errormessage={`participant-name-error-${p.index}`}
                        className={`form-control ${props.readOnly ? "read-only-input" : ""} ${
                            p.isActive ? "border border-2 border-success" : ""
                        }`}
                        type="text"
                        value={p.name}
                        onChange={(e) => nameChangeHandler(p, e.target.value)}
                        readOnly={props.readOnly}
                    />
                    <div className="d-flex justify-content-start">
                        <span className="text-danger" id={`participant-name-error-${p.index}`}>
                            {p.nameErrorMessage}
                        </span>
                    </div>
                </div>
                <div className="form-group col-5 person-phone-number">
                    <input
                        id={`participant-phone-number-${p.index}`}
                        aria-errormessage={`participant-phone-number-error-${p.index}`}
                        className={`form-control ${props.readOnly ? "read-only-input" : ""} ${
                            p.isActive ? "border border-2 border-success" : ""
                        }`}
                        type="text"
                        placeholder="e.g. +46705555555"
                        value={p.phoneNumber}
                        onChange={(e) => phoneNumberChangeHandler(p, e.target.value)}
                        readOnly={props.readOnly}
                    />
                    <div className="d-flex justify-content-start">
                        <span id={`participant-phone-number-error-${p.index}`} className="text-danger">
                            {p.phoneNumberErrorMessage}
                        </span>
                    </div>
                </div>
                <div className="col-1 d-flex align-items-end">
                    {!props.readOnly ? (
                        <>
                            <button
                                className="btn btn-secondary rounded-3 me-1"
                                type="button"
                                onClick={() => addParticipantClickHandler(p)}
                            >
                                <i className="fas fa-plus"></i>
                            </button>
                            {p.index > 0 ? (
                                <button
                                    className="btn btn-secondary rounded-3"
                                    type="button"
                                    onClick={() => removeParticipantClickHandler(p)}
                                >
                                    <i className="fas fa-minus"></i>
                                </button>
                            ) : null}
                        </>
                    ) : null}
                </div>
            </div>
        </li>
    ));

    return (
        <div className="text-bg-light mt-3 pt-2 pb-2 rounded-3">
            {props.showUpdateButton ? (
                <Button className="mb-3" onClick={props.onUpdateButtonClick}>
                    {props.resources.get("UpdateParticipants")}
                </Button>
            ) : null}
            <div className="row">
                <div className="col-1 text-center">
                    <label className="form-label fw-bold">{props.resources.get("OnSite")}</label>
                </div>
                <label className="form-label fw-bold col-5">{props.resources.get("Name")}</label>
                <label className="form-label fw-bold col-5">{props.resources.get("PhoneNumber")}</label>
            </div>

            <ul className="list-group" id="person-list" style={{ listStyle: "none" }}>
                {participantElements}
            </ul>
        </div>
    );
}

export default ParticipantsList;

export function ParticipantListItem_default(): ParticipantListItem {
    const participantListItem: ParticipantListItem = {
        index: 0,
        isActive: false,
        name: "",
        phoneNumber: "",
        nameErrorMessage: "",
        phoneNumberErrorMessage: ""
    };

    return participantListItem;
}
